<template>
    <div :aria-busy="loading">
        <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="loadError"
                error-text="加载失败，点击重新加载"
                :immediate-check="false"
                finished-text=""
                @load="onLoad"
                :offset="100"
        >
            <div @click="contents(item)" v-for="(item,index) in tableData" :key="item.id || index"
                 class="cards">
                <div class="card_top">
                    <img src="../../assets/image/h5/word.png" alt="">
                    <span>{{ item.title.length > 15 ? item.title.slice(0, 15) + '...' : item.title }}</span>
                </div>
                <div class="card_bottom">
                    <div class="card_bottom_left">
                        <span>{{ item.author.length > 9 ? item.author.slice(0,9) : item.author}}</span>
                        <span><img src="../../assets/image/h5/doc.png" alt="">{{ item.pages }} 页</span>
                    </div>
                    <div class="card_bottom_right">
                        <img src="../../assets/image/h5/bxz.png" alt="">
                        标小助
                    </div>
                </div>
            </div>

        </van-list>
        <custom-prompt v-if="showCustomPrompt" :empty="tableData.length === 0" />
    </div>
</template>

<script>
import {getListByCategory} from "@/api/phone/modelTopic";
import {navigatePhoneUrl, removeEmptyField} from "@/utils/resToData";
import {parseTime} from "@/utils/parse";
import customPrompt from '@/components/phone/custom_prompt';


export default {
    name: "card",
    components: {customPrompt},
    props: ['searchForm', 'status'],
    data() {
        return {
            form: {
                pageNum: 1,
                pageSize: 10,
                bidType: 0,
                categoryId: '',
                keyWord: '',
                maxPage: '',
                minPage: '',
                type: 0
            },
            totalCount: 0,
            loading: false,
            finished: false,
            loadError: false,
            hasLoaded: false,
            inFlight: false,
            queryKey: null,
            requestVersion: 0,
            disposed: false,
            tableData: []
        }
    },
    computed: {
        showCustomPrompt() {
            return this.hasLoaded && this.finished && !this.loading && !this.inFlight && !this.loadError
        }
    },
    mounted() {
        this.$bus.$on('cardInfo', this.resetSearch)
        this.$nextTick(() => this.resetSearch(this.searchForm))
    },

    beforeDestroy() {
        this.disposed = true
        this.requestVersion += 1
        this.$bus.$off('cardInfo', this.resetSearch)
    },

    methods: {
        contents(item) {
            sessionStorage.removeItem('historyUrls')
            navigatePhoneUrl('/phoneContent', {doc: item.id})

            // this.$router.push('/phoneContent')
        },

        onLoad() {
            if (this.inFlight || this.finished || !this.queryKey) {
                return
            }
            return this.getByCategory()
        },
        resetSearch(data = {}) {
            if (this.disposed) {
                return
            }
            data = data || {}
            const form = {
                pageNum: 1,
                pageSize: Number(data.pageSize) || 10,
                bidType: Number(data.bidType) || 0,
                categoryId: Number(data.categoryId) || '',
                keyWord: data.keyWord || '',
                maxPage: Number(data.maxPage) || '',
                minPage: Number(data.minPage) || '',
                type: Number(data.type) || 0
            }
            const queryKey = JSON.stringify(form)
            // 同一次筛选可能同时通过属性和事件传入，只发起一次请求。
            if (queryKey === this.queryKey && (this.inFlight || this.hasLoaded)) {
                return
            }
            this.requestVersion += 1
            this.queryKey = queryKey
            this.form = form
            this.tableData = []
            this.totalCount = 0
            this.finished = false
            this.loadError = false
            this.hasLoaded = false
            this.inFlight = false
            return this.getByCategory()
        },
        async getByCategory() {
            const version = this.requestVersion
            const form = {...this.form}
            this.inFlight = true
            this.loading = true
            this.loadError = false
            try {
                const res = await getListByCategory(removeEmptyField(form))
                if (version !== this.requestVersion) {
                    return
                }
                if (!res || !Array.isArray(res.H5BidList) || !Number.isFinite(Number(res.totalCount)) || Number(res.totalCount) < 0) {
                    throw new Error('加载失败')
                }
                const list = res.H5BidList.map(value => ({...value, createTime: parseTime(value.createTime)}))
                this.tableData.push(...list)
                this.totalCount = Number(res.totalCount)
                this.hasLoaded = true
                this.finished = form.pageNum * form.pageSize >= this.totalCount || list.length === 0
                this.form.pageNum = form.pageNum + 1
            } catch (err) {
                if (version === this.requestVersion) {
                    this.loadError = true
                }
            } finally {
                if (version === this.requestVersion) {
                    this.inFlight = false
                    this.loading = false
                }
            }
        },
    },

    watch: {
        searchForm: {
            deep: true,
            handler(newValue) {
                this.resetSearch(newValue)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.cards {
  margin-bottom: 0.1rem;
  width: 100%;
  height: 0.95rem;
  background: #FFFFFF;
  box-shadow: 0px 0px 14px 0px rgba(142, 150, 164, 0.03);
  border-radius: 0.1rem;
  opacity: 1;
  padding: 0.15rem;
  box-sizing: border-box;

  .card_top {
    height: 0.36rem;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 0 0.1rem 0;
    box-sizing: border-box;
    border-bottom: 1px solid #F3F4F6;

    img {
      height: 0.16rem;
    }

    span {
      font-size: 0.16rem;
      color: #333333;
      margin-left: 0.1rem;
    }
  }

  .card_bottom {
    height: 0.36rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.22rem 0;
    box-sizing: border-box;

    .card_bottom_left {
      color: #999999;
      font-size: 0.14rem;
      display: flex;
      align-items: center;

      span {
        margin-right: 0.12rem;

        img {
          height: 0.14rem;
        }
      }
    }

    .card_bottom_right {
      width: 1rem;
      display: flex;
      align-items: center;
      justify-content: right;
      color: #999999;

      img {
        height: 0.14rem;
      }
    }
  }
}

</style>
